import {
  FeedsEndpoints,
  IGetFeedsDTO,
  IGetFeedsResponse,
  IGetFeedDTO,
  IGetFeedResponse,
  ICreateFeedDTO,
  IUpdateFeedDTO,
  IDeleteFeedDTO,
  IRegenerateFeedDTO,
  IExportFeedDTO,
  ICountProductsDTO,
  ICountProductsResponse,
} from '@/models/feeds.model';
import { ApiResponse, httpClient } from '@/utils';

class FeedsAPI {
  static getFeeds(data: IGetFeedsDTO): ApiResponse<IGetFeedsResponse> {
    return httpClient.get<IGetFeedsResponse>(FeedsEndpoints.FEEDS, { params: data });
  }

  static getFeed(data: IGetFeedDTO): ApiResponse<IGetFeedResponse> {
    return httpClient.get<IGetFeedResponse>(`${FeedsEndpoints.FEEDS}/${data.id}`);
  }

  static createFeed(data: ICreateFeedDTO): ApiResponse<IGetFeedResponse> {
    return httpClient.post<IGetFeedResponse>(FeedsEndpoints.FEEDS, data);
  }

  static regenerateFeed(data: IRegenerateFeedDTO): ApiResponse<IGetFeedResponse> {
    return httpClient.post<IGetFeedResponse>(`${FeedsEndpoints.FEEDS}/${data.feed_id}/regenerate`, data);
  }

  static updateFeed({ id, ...data }: IUpdateFeedDTO): ApiResponse<IGetFeedResponse> {
    return httpClient.put<IGetFeedResponse>(`${FeedsEndpoints.FEEDS}/${id}`, data);
  }

  static deleteFeed(data: IDeleteFeedDTO): ApiResponse<void> {
    return httpClient.delete<void>(`${FeedsEndpoints.FEEDS}/${data.id}`);
  }

  static getExportFeeds(params: IExportFeedDTO): ApiResponse<Blob> {
    return httpClient.get<Blob>(`${FeedsEndpoints.FEEDS}/${params.feed_id}/download/${params.locale}`, {
      params,
      responseType: 'blob',
    });
  }

  static countProducts(data: ICountProductsDTO): ApiResponse<ICountProductsResponse> {
    return httpClient.post<ICountProductsResponse>(`${FeedsEndpoints.FEEDS}/count-products`, data);
  }

  static previewXml(data: ICountProductsDTO): ApiResponse<string> {
    return httpClient.post<string>(`${FeedsEndpoints.FEEDS}/preview-xml`, data, {
      responseType: 'text',
      transformResponse: [(raw: string) => raw],
    });
  }
}

export default FeedsAPI;
